import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LOG_IN_ROUTE } from '../../shared/common/constants';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * JWT Interceptor function
 * Adds an Authorization header with JWT if the user is logged in
 * and the request is to an API URL.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const accessToken = authService.currentUser()?.token;
  const isLoggedIn = authService.checkIfLoggedIn();
  const isApiUrl =
    req.url.startsWith(environment.mainapiUrl) ||
    req.url.startsWith(environment.messagingUrl) ||
    req.url.startsWith(environment.dispatchUrl) ||
    req.url.startsWith(environment.BIUrl);
  if (isLoggedIn && isApiUrl) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        if (!environment.developmentMode && !environment.isStandalonePortal) {
          const url = environment.localDomain + LOG_IN_ROUTE;
          window.open(url, '_self');
          clearStorage();
        } else if (environment.isStandalonePortal) {
          router.navigate([LOG_IN_ROUTE]);
          clearStorage();
        }
      }
      return throwError(() => new Error('Error happened'));
    }),
  );
};

const clearStorage = () => {
  sessionStorage.clear();
  localStorage.clear();
};
